import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { CampaignsManagementTaskBoardComponent } from './campaigns-management-task-board.component';

const routes: Routes = [
  {
    path: '',
    component: CampaignsManagementTaskBoardComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  providers: [],
  exports: [RouterModule],
})
export class CampaignsManagementTaskBoardRoutingModule {}
